import { z } from 'zod';
import { SUPPLIER_LOYALTY_CODE, uniqueCodes } from './loyalty_codes';

/** Teto da lista de programas de hotel por viajante — os mesmos 20 da lista
 *  aérea (`TravelerProfilePatchSchema.mileagePlans`, literal lá). */
export const HOTEL_LOYALTY_PROGRAMS_MAX = 20;

/**
 * Programa de fidelidade de HOTEL do viajante (spec 2026-09-17). O legado não
 * tem este campo, então ele vive num store do customer-api
 * (`hotel_loyalty_programs`) — a exceção sancionada em "Profile truth".
 * `chainCode` é o `codes[0]` do catálogo: o Sabre chain code (2 chars), que
 * vira `LoyaltyIds/LoyaltyId` na busca e `Guest/@LoyaltyId` na reserva, ou a
 * chave própria (3–12 chars) de um programa sem código na Sabre, que nunca vai
 * para ela (`isSabreChainCode`); `chainName`
 * é o `owner` do catálogo para a leitura não depender dele; `number` só `trim`.
 */
export const HotelLoyaltyProgramSchema = z
  .object({
    chainCode: z.string().regex(SUPPLIER_LOYALTY_CODE),
    chainName: z.string().min(1).max(80),
    number: z.string().trim().min(1).max(40),
  })
  .strict();
export type HotelLoyaltyProgram = z.infer<typeof HotelLoyaltyProgramSchema>;

/** Wire de leitura E de escrita (`PUT` substitui a lista inteira). */
export const HotelLoyaltyProgramsSchema = z
  .object({
    programs: z
      .array(HotelLoyaltyProgramSchema)
      .max(HOTEL_LOYALTY_PROGRAMS_MAX)
      .superRefine(uniqueCodes((row) => row.chainCode, 'chainCode')),
  })
  .strict();
export type HotelLoyaltyPrograms = z.infer<typeof HotelLoyaltyProgramsSchema>;
